import styled from '@emotion/styled'

import { sizeToProps } from '../../constants/sizeToProps'
import { InputPrefixSuffix } from '../InputPrefixSuffix'

export const InputPrefixWrapper = styled(InputPrefixSuffix)`
  margin-right: ${({ inputSize }) => sizeToProps[inputSize].spacingX};
  padding-right: 0;
`
